import { UserModel } from "../UserModel";
import { DetailItem, DetailSection, DateFormatHelper, AppEnumHelper, OptionHelper, UserEnums, stringCompare, DOMAIN_CONFIGS, DOMAIN_TYPES, formatName } from "@/Shared";
import { PersonViewModel } from "@/Domains/Person/Logic/ViewModels/PersonViewModel";
import { AuditModel } from "@/Shared/Logic/Models/AuditModel";
import { AccessRightModel } from "@/Domains/Auth";

export interface UserVMParams {
    user: UserModel;
    viewEnums: UserEnums;
    accessRight: AccessRightModel;
    isDisplaying: boolean;
}

export class UserViewModel extends PersonViewModel {

    public hiredDate!: string;
    public firedDate!: string;
    public role!: string;
    public username!: string;
    public managerName!: string;
    public model!: UserModel;
    public isDeleted!: boolean;
    public cardClass!: string;
    public positions! : string;


    public constructor(protected params: UserVMParams) {
        super(params.user.person, params.viewEnums.CivilityEnum);
        this.model = params.user;
        this.init();
    }

    init = () => {
        this.isDeleted = !!this.model.deletedAt
        this.cardClass = this.params.isDisplaying ? 'active' : '';
        this.managerName = formatName(this.model.manager?.person);
        this.username = this.model.username ?? "";
        this.hiredDate = DateFormatHelper.toLocaleDateString(this.model.hiredAt);
        this.firedDate = DateFormatHelper.toLocaleDateString(this.model.firedAt);
        this.audit.initialize(this.model as AuditModel);
        this.role = AppEnumHelper.getLabel(this.params.viewEnums.UserRoleEnum, this.model.role);
        
        this.positions = (this.model.positions ?? []).map(
            position => AppEnumHelper.getLabel(this.params.viewEnums.UserPositionEnum, position)
        ).join(', ');
        return this;
    }


    get hiringSection() {
        return [
            { label: "Profession", value: this.profession },
            { label: "Fonctions", value: this.positions },
            { label: "Embauché(e) le", value: this.hiredDate },
            { label: "Licencié(e) le", value: this.firedDate },
            { label: "Manager", value: this.managerName },
        ] as DetailItem[];
    }

    static userOptions(userList: UserModel[]) {
        return OptionHelper.userOptions(userList);
    }


    getAllSections = (): DetailSection[] => {
        const sections: DetailSection[] = [
            {
                sectionFn: () => [
                    ...this.civilitySection, 
                    { label: "Pseudo", value: this.username }, 
                    { label: "Rôle", value: this.role }
                ],
                legend: 'Civilité',
                type: 'box'
            },
            {
                sectionFn: () => this.localisationSection,
                legend: 'Localisation',
                type: 'box'
            },
            {
                sectionFn: () => this.coordinatesSection,
                legend: 'Coordonnées',
                type: 'box'
            },
            {
                sectionFn: () => this.hiringSection,
                legend: 'Statut',
                type: 'box'
            }
        ];
        if (this.params.accessRight.canAudit(DOMAIN_TYPES.User)) {
            sections.push(
                {
                    sectionFn: this.audit.getAuditTrail,
                    legend: 'Traçabilité',
                    type: 'box'
                }
            );
        }
        return sections;
    }

    get title() {
        return super.getTitle(DOMAIN_CONFIGS.User.domainLabel);
    }

    compareTo(other: UserViewModel): number {
        return stringCompare(this.fullName ?? "", other.fullName ?? "");
    }
}